import ProtectedRoute from "@/components/protected-route";
import EditionLayout from "@/layouts/edition/edition-layout";
import Root from "@/layouts/general/main-layout";
import RegistrationLayout from "@/layouts/registration/registration-layout";
import CompanyPage from "@/modules/company/company.page";
import EnrollmentPage from "@/modules/enrollment/enrollment.page";
import RegisterNewCompanyPage from "@/modules/enrollment/register-new-company.page";
import ErrorPage from "@/modules/errors/error.page";
import NotFoundPage from "@/modules/errors/not-found.page";
import Home from "@/modules/home/home.page";
import LibraryPage from "@/modules/library/library.page";
import PreviousEditionPage from "@/modules/previous-editions/previous-edition/previous-edition.page";
import QuizHistoryPreview from "@/modules/previous-editions/previous-edition/quiz-history-preview";
import PreviousEditionsPage from "@/modules/previous-editions/previous-editions.page";
import QuizDimensionPage from "@/modules/quiz/dimension/quiz-dimension.page";
import QuizPage from "@/modules/quiz/quiz.page";
import DimensionResults from "@/modules/results/dimension/dimension-results.page";
import GeneralIndicatorsPage from "@/modules/results/general-indicators/general-indicators.page";
import ResultsPage from "@/modules/results/results.page";
import WelcomePage from "@/modules/welcome/welcome.page";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

const routerFutureFlags = {
  future: {
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_relativeSplatPath: true,
    v7_skipActionErrorRevalidation: true,
  },
};

const appRouter = createBrowserRouter(
  [
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <Root />
        </ProtectedRoute>
      ),
      errorElement: <ErrorPage />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: "welcome",
          element: <WelcomePage />,
        },
        {
          path: "editions/:editionId",
          element: <EditionLayout />,
          children: [
            {
              path: "quiz",
              element: <QuizPage />,
            },
            {
              path: "quiz/dimensions/:dimensionId",
              element: <QuizDimensionPage />,
            },
            {
              path: "quizzes/:quizId/results",
              element: <ResultsPage />,
              children: [
                {
                  path: "",
                  element: <Navigate to="general" replace />,
                },
                {
                  path: "general",
                  element: <GeneralIndicatorsPage />,
                },
                {
                  path: ":dimensionId",
                  element: <DimensionResults />,
                },
              ],
            },
          ],
        },
        {
          path: "library",
          element: <LibraryPage />,
        },
        {
          path: "company",
          element: <CompanyPage />,
        },
        {
          path: "previous-editions",
          element: <PreviousEditionsPage />,
        },
        {
          path: "previous-editions/:editionId",
          element: <PreviousEditionPage />,
          children: [
            {
              path: ":dimensionId",
              element: <QuizHistoryPreview />,
            },
          ],
        },
      ],
    },
    {
      path: "/enroll/:editionId",
      element: (
        <ProtectedRoute>
          <RegistrationLayout />
        </ProtectedRoute>
      ),
      errorElement: <ErrorPage />,
      children: [
        {
          path: "",
          element: <EnrollmentPage />,
        },
      ],
    },
    {
      path: "/signup",
      element: <RegistrationLayout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "",
          element: <RegisterNewCompanyPage />,
        },
      ],
    },
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ],
  routerFutureFlags,
);

const AppRouterProvider = () => {
  return (
    <RouterProvider router={appRouter} future={{ v7_startTransition: true }} />
  );
};

export default AppRouterProvider;
